export const initAnalytics = (ga4) => {
    try {
        window.parent.postMessage({
            type: 'streamchat:init-analytics',
            payload: { ga4 }
        }, '*');
    } catch {}
}
